import {combineReducers} from "redux"
import apps from "./apps"
import documents from "./documents"
import me from "./me"
import uploads from "./uploads"
import users from "./users"

// SELECTORS
export const getPortal = (state) => state.portal

// REDUCER
export default combineReducers({
  apps,
  documents,
  me,
  uploads,
  users,
})
